const footerLinks = {
  Produtos: ['Skincare', 'Maquiagem', 'Corpo', 'Cabelos', 'Kits & Presentes'],
  Empresa: ['Sobre Nós', 'Blog de Beleza', 'Carreiras', 'Sustentabilidade', 'Imprensa'],
  Atendimento: ['Central de Ajuda', 'Rastrear Pedido', 'Trocas e Devoluções', 'Política de Privacidade', 'Termos de Uso'],
};

export default function Footer() {
  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#0A3D3D] text-white">
      {/* Newsletter */}
      <div className="border-b border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-12">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-6">
            <div>
              <h3 className="font-display text-2xl font-semibold mb-1">
                Receba Novidades Exclusivas
              </h3>
              <p className="text-white/60 text-sm">
                Inscreva-se e ganhe 10% de desconto na primeira compra.
              </p>
            </div>
            <div className="flex gap-3 w-full lg:w-auto">
              <input
                type="email"
                placeholder="Seu melhor e-mail"
                className="flex-1 lg:w-72 bg-white/10 border border-white/20 rounded-full px-5 py-3 text-sm text-white placeholder-white/40 focus:outline-none focus:border-[#7FCECC] transition-colors"
              />
              <button className="bg-[#0F7C7A] hover:bg-[#7FCECC] hover:text-[#0A3D3D] text-white font-semibold px-6 py-3 rounded-full transition-colors cursor-pointer whitespace-nowrap text-sm">
                Inscrever
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-14">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-10">
          {/* Brand */}
          <div className="lg:col-span-2">
            <img
              src="https://static.readdy.ai/image/61892072331720d5ae52870a50f3ccd8/20cef7de92f0add5ce8c53134a30c56c.png"
              alt="Logo"
              className="h-12 w-auto object-contain mb-5 brightness-0 invert"
            />
            <p className="text-white/60 text-sm leading-relaxed max-w-xs mb-6">
              Cosméticos premium que unem a riqueza da natureza brasileira com tecnologia de ponta para realçar sua beleza única.
            </p>
            <div className="flex gap-3">
              {[
                { icon: 'ri-instagram-line' },
                { icon: 'ri-facebook-circle-line' },
                { icon: 'ri-tiktok-line' },
                { icon: 'ri-youtube-line' },
                { icon: 'ri-pinterest-line' },
              ].map((s, i) => (
                <a
                  key={i}
                  href="#"
                  rel="nofollow"
                  className="w-9 h-9 flex items-center justify-center border border-white/20 hover:border-[#7FCECC] hover:bg-[#7FCECC]/10 text-white/60 hover:text-[#7FCECC] rounded-full transition-all duration-300 cursor-pointer"
                >
                  <i className={`${s.icon} text-base`} />
                </a>
              ))}
            </div>
          </div>

          {/* Links */}
          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-white font-semibold text-sm mb-5 tracking-wide uppercase">
                <a href="#">{title}</a>
              </h4>
              <ul className="space-y-3">
                {links.map((link) => (
                  <li key={link}>
                    <a
                      href="#"
                      rel="nofollow"
                      onClick={(e) => { e.preventDefault(); scrollTo('home'); }}
                      className="text-white/55 hover:text-[#7FCECC] text-sm transition-colors cursor-pointer"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      {/* Bottom */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/40 text-xs">
            © {new Date().getFullYear()} Lumière Cosméticos. Todos os direitos reservados.
          </p>
          <div className="flex items-center gap-6">
            {['Visa', 'Mastercard', 'Pix', 'Boleto'].map((pay) => (
              <span key={pay} className="text-white/30 text-xs font-medium">
                {pay}
              </span>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
